import { useCallback, useEffect, useState } from "react";
import { Send, Users, Mail, FileText } from "lucide-react";
import api from "@/lib/api";
import CampaignComposer from "./mailing/CampaignComposer";
import CampaignList from "./mailing/CampaignList";
import GroupsPanel from "./mailing/GroupsPanel";
import RecipientsPanel from "./mailing/RecipientsPanel";
import SubscribersPanel from "./mailing/SubscribersPanel";
import TemplatesPanel from "./mailing/TemplatesPanel";

const TABS = [["kampanie", "Kampanie", Send], ["szablony", "Szablony", FileText], ["odbiorcy", "Grupy i adresaci", Users], ["subskrybenci", "Subskrybenci", Mail]];

export default function NewsletterAdmin() {
    const [tab, setTab] = useState("kampanie");
    const [groups, setGroups] = useState([]);
    const [campaigns, setCampaigns] = useState([]);
    const [draft, setDraft] = useState(null);
    const [groupId, setGroupId] = useState("");

    const loadGroups = useCallback(() => api.get("/mailing/groups").then((r) => setGroups(r.data || [])), []);
    const loadCampaigns = useCallback(() => api.get("/mailing/campaigns").then((r) => setCampaigns(r.data || [])), []);
    useEffect(() => { loadGroups(); loadCampaigns(); }, [loadGroups, loadCampaigns]);

    return (
        <div className="space-y-6" data-testid="mailing-admin">
            <div className="flex flex-wrap items-center gap-2">
                {TABS.map(([k, l, Icon]) => (
                    <button key={k} onClick={() => setTab(k)} data-testid={`mailing-tab-${k}`}
                        className={`inline-flex items-center gap-2 px-4 py-2 rounded-full text-sm transition-colors ${tab === k ? "bg-[#092E22] text-white" : "bg-white border border-gray-200 text-[#092E22] hover:border-[#0D4F3C]/40"}`}>
                        <Icon size={14} /> {l}
                    </button>
                ))}
                <p className="text-xs text-amber-700 bg-amber-50 border border-amber-200 rounded-full px-3 py-1.5 lg:ml-auto">
                    Wysyłka wymaga skonfigurowanego dostawcy (Resend lub Amazon SES) w „Ustawieniach”.
                </p>
            </div>
            {tab === "kampanie" && (
                <div className="grid xl:grid-cols-[3fr_2fr] gap-6 items-start">
                    <CampaignComposer groups={groups} draft={draft} onSaved={() => { setDraft(null); loadCampaigns(); }} />
                    <CampaignList campaigns={campaigns} reload={loadCampaigns} onEditDraft={(d) => { setDraft(d); window.scrollTo({ top: 0, behavior: "smooth" }); }} />
                </div>
            )}
            {tab === "odbiorcy" && (
                <div className="grid lg:grid-cols-[280px_1fr] gap-6 items-start">
                    <GroupsPanel groups={groups} selected={groupId} onSelect={setGroupId} reload={loadGroups} />
                    <RecipientsPanel groups={groups} groupId={groupId} onChanged={loadGroups} />
                </div>
            )}
            {tab === "szablony" && <TemplatesPanel />}
            {tab === "subskrybenci" && <SubscribersPanel onChanged={loadGroups} />}
        </div>
    );
}
